export enum SiteLevel {
  COUNTRY = "country",
  PROVINCE = "province",
  STATE = "state",
  CITY = "city",
  ADDRESS = "address",
}
